import { z } from 'zod';
import {
    type NodeSocketCfg,
    baseNodeCfgSchema,
} from './base-node';

const baseComparisonSchema = z.object({
    kind: z.string(),
    operation: z.enum([ '=', '!=' ]),
});

const materialModelComparisonSchema = baseComparisonSchema.extend({
    kind: z.literal('materialModel'),
    materialModelId: z.string().uuid(),
});

const materialClassComparisonSchema = baseComparisonSchema.extend({
    kind: z.literal('materialClass'),
    materialClassId: z.string().uuid(),
});

const comparisonCfgSchema = z.discriminatedUnion('kind', [
    materialModelComparisonSchema,
    materialClassComparisonSchema,
]);

export type MaterialComparisonCfg = z.infer<typeof comparisonCfgSchema>;

export const materialComparisonNodeCfgSchema = baseNodeCfgSchema.extend({
    kind: z.literal('materialComparison'),
    controlValues: z.object({
        comparisonCfg: comparisonCfgSchema,
    }),
});
export interface MaterialComparisonNodeCfgSchema extends z.infer<typeof materialComparisonNodeCfgSchema> {}

export const materialComparisonNodeCfg = {
    controlSockets: {
        inputs: () => ({}),
        outputs: () => ({}),
    },
    dataSockets: {
        outputs: () => ({
            result: 'boolean',
        }),
        inputs: () => {
            return {
                // todo: uuid type
                materialId: 'string',
            };
        },
    },
} satisfies NodeSocketCfg<MaterialComparisonNodeCfgSchema>;
